module.exports = __webpack_public_path__ + "static/media/upload.925fc5db.svg";